import { useState } from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

export default function AuditSearch({ handleAuditSearch }) {
  const [jobId, setJobId] = useState("")
  const [date, setDate] = useState(null)
  const [status, setStatus] = useState("")

  const CustomInput = ({ value, onClick }) => (
    <input
      type="text"
      value={value}
      onClick={onClick}
      readOnly
      className="date-picker"
      placeholder="Select Date"
    />
  )

  return (
    <div className="audit-search-container">
      <span style={{ marginRight: "20px", color: "#ccc" }}>|</span>
      <input
        type="text"
        placeholder="Job ID"
        value={jobId}
        onChange={(e) => setJobId(e.target.value)}
        style={{ width: "400px", outline: "none" }}
      />
      <div className="date-picker-container">
        {/* <DatePicker
          selected={date}
          onChange={(date) => setDate(date)}
          className="date-picker"
          placeholderText="Select Date"
          popperPlacement="top-start"
          popperModifiers={[
            { name: "preventOverflow", options: { boundary: "viewport" } },
          ]}
        /> */}

        <DatePicker
          selected={date}
          onChange={(date) => setDate(date)}
          customInput={<CustomInput />}
          isClearable
        />
      </div>
      <select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
        className="select-field"
        style={{ color: status ? "black" : "grey" }}
      >
        <option value="">Select Status</option>
        <option value="ERROR">ERROR</option>
        <option value="COMPLETE">COMPLETE</option>
      </select>
      <button
        className="faxes-button"
        onClick={() => handleAuditSearch({ jobId, date, status })}
        style={{ padding: "12px" }}
      >
        Search
      </button>
      <button
        className="faxes-button"
        onClick={() => {
          setJobId("")
          setDate(null)
          setStatus("")
          handleAuditSearch({ jobId: "", date: null, status: "" })
        }}
        style={{ padding: "12px", marginLeft: "3px" }}
      >
        Reset
      </button>
    </div>
  )
}
